import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import UnicityLogoWhite from '@/core/components/coming-soon/UnicityLogoWhite'
import CCTitle from '@/core/components/coming-soon/CCTitle'

// Target date: January 22, 2027
const TARGET_DATE = new Date('January 22, 2027 00:00:00').getTime()

const Container = styled(Box)({
    width: '100%',
    minHeight: '100vh',
    margin: '0 auto',
    backgroundColor: '#003B6F',
    backgroundImage: 'url(/assets/coming-soon/bg.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '58px 32px',
    boxSizing: 'border-box',
    gap: '48px'
})

const Title = styled(Typography)({
    fontSize: '28px',
    fontWeight: 700,
    color: 'rgba(255, 255, 255, 1)',
    marginBottom: '0px',
    lineHeight: '40px',
    fontFamily: 'Inter'
})

const Subtitle = styled(Typography)({
    fontSize: '22px',
    fontWeight: 500,
    color: 'rgba(255, 255, 255, 1)',
    lineHeight: '28px',
    fontFamily: 'Inter'
})

const CountdownNumber = styled(Typography)({
    fontSize: '36px',
    fontWeight: 600,
    color: 'rgba(255, 255, 255, 1)',
    fontFamily: 'Inter'
})

const CountdownLabel = styled(Typography)({
    fontSize: '12px',
    fontWeight: 600,
    color: 'rgba(255, 255, 255, 1)',
    fontFamily: 'Inter'
})

const CountdownDivider = styled(Typography)({
    fontSize: '24px',
    fontWeight: 500,
    color: 'rgba(255, 255, 255, 1)',
    fontFamily: 'Inter',
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: '8px'
})

interface CountdownValues {
    days: string
    hours: string
    minutes: string
    seconds: string
}

const ComingSoonPage = () => {
    const [countdown, setCountdown] = useState<CountdownValues>({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
    })

    useEffect(() => {
        const updateCountdown = () => {
            const now = new Date().getTime()
            const difference = TARGET_DATE - now

            if (difference > 0) {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24))
                const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
                const seconds = Math.floor((difference % (1000 * 60)) / 1000)

                setCountdown({
                    days: String(days).padStart(2, '0'),
                    hours: String(hours).padStart(2, '0'),
                    minutes: String(minutes).padStart(2, '0'),
                    seconds: String(seconds).padStart(2, '0')
                })
            } else {
                setCountdown({
                    days: '00',
                    hours: '00',
                    minutes: '00',
                    seconds: '00'
                })
            }
        }

        updateCountdown()
        const interval = setInterval(updateCountdown, 1000)

        return () => clearInterval(interval)
    }, [])

    return (
        <Container>
            <UnicityLogoWhite />

            <Box display="flex" boxSizing="border-box">
                <CCTitle />
            </Box>

            <Stack textAlign="center" color="white" gap="24px">
                <Stack>
                    <Title>January 22-23, 2027</Title>
                    <Title>Bangkok, Thailand</Title>
                </Stack>
                <Stack>
                    <Subtitle>Countdown to the opening of our GLIC online store</Subtitle>
                </Stack>
            </Stack>

            <Stack direction="row" gap="8px">
                <Stack alignItems="center" width="70px">
                    <CountdownNumber>{countdown.days}</CountdownNumber>
                    <CountdownLabel>Days</CountdownLabel>
                </Stack>
                <CountdownDivider>:</CountdownDivider>
                <Stack alignItems="center" width="70px">
                    <CountdownNumber>{countdown.hours}</CountdownNumber>
                    <CountdownLabel>Hours</CountdownLabel>
                </Stack>
                <CountdownDivider>:</CountdownDivider>
                <Stack alignItems="center" width="70px">
                    <CountdownNumber>{countdown.minutes}</CountdownNumber>
                    <CountdownLabel>Minutes</CountdownLabel>
                </Stack>
                <CountdownDivider>:</CountdownDivider>
                <Stack alignItems="center" width="70px">
                    <CountdownNumber>{countdown.seconds}</CountdownNumber>
                    <CountdownLabel>Seconds</CountdownLabel>
                </Stack>
            </Stack>
        </Container>
    )
}

export default ComingSoonPage
